import { Component } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { InitDataService } from '../../system-services/InitData/InitData.service';
import { Logger } from '../../system-services/Logger/Logger.service';
import { TranslationService } from '../../translations/Translation.service';
import { MyProfileTooltipService } from '../profile-tooltip/my-profile-tooltip.service';

@Component({
    selector: 'my-profile-tooltip-pending',
    templateUrl: 'my-profile-tooltip-pending.component.html',
    styleUrls: ['./my-profile-tooltip-pending.less'],
    standalone: false
})
export class MyProfileTooltipPendingComponent {
    IconType = IconType;
    IconSize = IconSize;

    constructor(
        private myProfileService: MyProfileTooltipService,
        private logger: Logger,
        private initData: InitDataService,
        public TR: TranslationService
    ) {}

    async openNewTab(e: Event) {
        e.stopPropagation(); // To prevent clickOutside directive on the my profile tooltip from firing
        e.preventDefault();

        const assessmentUrl = this.myProfileService.assessmentUrl;

        await this.myProfileService.createAndSubscribeToPoll();

        this.logger.logInfo(
            'My Profile - BA Experience take assessment button clicked',
            {
                email: this.initData.user.email
            }
        );

        const administeredById =
            this.extractPendingAssessmentAdministeredById();
        this.logger.logInfo(
            'Tracks AdministeredById, Assessment Taker Id and whether it is Self Administered Assessment',
            {
                userId: this.initData.user.userGuid,
                email: this.initData.user.email,
                administeredById: administeredById,
                isSelfAdministeredAssessment:
                    this.initData.user.userGuid === administeredById
            }
        );

        const baWindow = window.open(assessmentUrl, '_blank');
        // Needed to communicate across tabs to allow a button on the assessment side to close the assessment through this window.
        // javascript cannot be used to close windows themselves, only windows that are opened by another window and only then when the other window does it.
        const processCrossWindowMessage = function (
            event: MessageEvent<string>
        ) {
            if (assessmentUrl.startsWith(event.origin)) {
                baWindow.close();
                window.removeEventListener(
                    'message',
                    processCrossWindowMessage
                );
            }
        };

        window.addEventListener('message', processCrossWindowMessage);
    }

    private extractPendingAssessmentAdministeredById() {
        return this.myProfileService.person.behavioralAssessments.find(
            (x) => x.assessmentState === 10 // Pending state.
        )?.administeredById;
    }
}
